<span>{{utilsService.numberFormat(utilsService.roundPrices(value,3))}}</span><span *ngIf="displaysymbol">{{basketService.conversionArray[this.currency].symbol}}</span>
